'use client';

import Link from 'next/link';

import { LEAD_FORM_NAME } from '@/features/lead-form/constants/formName';
import { LEAD_TYPE } from '@/features/lead-form/constants/leadType';
import { FIELDS_AFFILIATE, Form, FORM_KEY } from '@publishing/modules/forms';

import s from '../ff-partners.module.scss';

import { GTM_EVENT } from '@/shared/constants/gtm';
import { gtmClick } from '@/shared/utils/gtm';

export function FfPartnersAffiliate() {
  return (
    <main className={`${s.affiliate_contact} h_full`}>
      <div className={s.inner}>
        <header className={s.contact_header}>
          <h1 className={s.title_h1}>기업 추천하기</h1>

          <p className={s.text_p1}>
            패파 파트너스 등록이 완료되셨다면,
            <br />
            패파의 사무실에 관심 있는 기업을 추천해 주세요.
            <br />
            실제 서비스 상담은 패파에서 진행하니
            <br />
            서비스를 잘 모르셔도 부담없이 추천할 수 있습니다.
          </p>

          <p className={s.text_box}>
            패파트너 등록 전이라면, <br className="hidden_pc" />
            <Link
              href="/ff-partners"
              className="ga4__cta_btn_link"
              {...gtmClick(GTM_EVENT.BTN, '여기', '/ff-partners')}
            >
              여기
            </Link>
            에서 등록 절차를 진행해 주세요!
            <br />
            3영업일 이내로 등록이 완료됩니다.
          </p>

          <div className={s.img_area} aria-hidden="true" />
        </header>

        <section className={s['contact-box']} aria-label="기업 추천 신청">
          <div className={s['form-box']}>
            <div className={s.leadforms_box}>
              <Form
                type={FORM_KEY.AFFILIATE}
                fields={FIELDS_AFFILIATE}
                formName={LEAD_FORM_NAME.AFFILIATE}
                leadType={[LEAD_TYPE.SHARED_OFFICE]}
                showTip={false}
                submitLabel="기업 추천하기"
                className={s.lead_form}
                actionAreaClassName={s.lead_form_actions}
              />
              <p className={s.caution_text}>
                *정보 제출은 추천 대상자의 정보 이용
                <br className="hidden_pc" /> 사전 동의 확인으로 간주됩니다.
              </p>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}
